define("appkit/utils/setup-twitter-widgets", 
  ["exports"],
  function(__exports__) {
    "use strict";
    /**
     * Load all twitter widgets after the views were rendered
     */
    __exports__["default"] = function() {

      Ember.View.reopen({
        loadTweets: function() {
          Ember.run.scheduleOnce('afterRender', function(){
            if (typeof twttr !== 'undefined') {
              twttr.widgets.load();
            }
          });
        }.on('didInsertElement')
      });

    }
  });